export default __webpack_public_path__ + "static/media/logo_cabre.31f6bdf4.svg";